import { defineCustomElement } from 'vue';
import PedidoRelatorios from '../../../src/vue/shared/filtro/filtros/relatorios/PedidoRelatorios.vue';
import plugins from '../../../src/vue/shared/filtro/plugins';
try {
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('filtro-relatorio-pedidos')) {
      const FiltroRelatorioPedidosElement = defineCustomElement(PedidoRelatorios, {
        shadowRoot: false,
        configureApp(app) {
          app.use(plugins);
        }
      });
      customElements.define('filtro-relatorio-pedidos', FiltroRelatorioPedidosElement);
    }
  });
} catch (error) {
  console.error('Falha ao definir o componente customizado:', error);
}
